module.exports = __webpack_public_path__ + "static/media/res-image.cf06efe8.png";